import { CheckCircle2, Loader2, X } from "lucide-react";
import { Button } from "@/components/ui/button";

export const ImportProgress = ({ rows, onReview, onCancel }) => {
  if (!rows.length) return null;
  const total = rows.length;
  const queued = rows.filter((r) => r.phase === "queued").length;
  const reading = rows.filter((r) => r.phase === "reading").length;
  const processed = total - queued - reading;
  const done = processed === total;
  const pct = Math.round((processed / total) * 100);
  return (
    <div className={`rounded-2xl border p-4 transition-colors ${done ? "border-emerald-200 bg-emerald-50/60" : "border-blue-200 bg-blue-50/60"}`} data-testid="import-progress">
      <div className="flex flex-wrap items-center gap-3">
        {done ? <CheckCircle2 className="w-5 h-5 text-emerald-600" /> : <Loader2 className="w-5 h-5 text-[#002FA7] animate-spin" />}
        <div className="flex-1 min-w-[180px]">
          <div className="font-semibold text-slate-900" data-testid="import-progress-title">
            {done ? `Done \u2014 all ${total} ratecon${total === 1 ? "" : "s"} read` : `Processing ${Math.min(processed + 1, total)} of ${total}`}
          </div>
          <div className="text-xs text-slate-600 mt-0.5" data-testid="import-progress-counts">
            {`${processed} processed \u00b7 ${reading} reading \u00b7 ${queued} queued`}
          </div>
        </div>
        {done
          ? <Button size="sm" onClick={onReview} className="bg-emerald-600 hover:bg-emerald-700 rounded-full" data-testid="import-progress-review">Review {total} load{total === 1 ? "" : "s"}</Button>
          : <Button size="sm" variant="ghost" onClick={onReview} data-testid="import-progress-peek">View progress</Button>}
        <button onClick={onCancel} className="p-1.5 rounded-full text-slate-400 hover:text-slate-700 hover:bg-white" aria-label="Cancel import" title="Cancel import" data-testid="import-progress-cancel"><X className="w-4 h-4" /></button>
      </div>
      <div className="mt-3 h-2 rounded-full bg-white overflow-hidden" role="progressbar" aria-valuenow={pct} aria-valuemin={0} aria-valuemax={100}>
        <div className={`h-full rounded-full transition-[width] duration-500 ${done ? "bg-emerald-500" : "bg-[#002FA7]"}`} style={{ width: `${pct}%` }} data-testid="import-progress-bar" />
      </div>
    </div>
  );
};
